import { Group, Input } from '@byecode/ui'
import { ListItem4ByecodeUi } from '@lighthouse/shared'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { InheritLabel } from '@/components/InheritLabel'
import { GapSizeInput } from '@/components/StyleSetting/AutoLayoutSetting/GapSizeInput'
import { useSetExtendsKeys } from '@/components/StyleSetting/hooks/useMouseEventDistance'
import { RectSizeInput } from '@/components/StyleSetting/SizeSetting/RectSizeInput'

import type { FieldInputFormSlice } from '../formSlice'

interface FileGridStyleProps {
    prefix?: string
}

export const FileGridStyle: React.FC<FileGridStyleProps> = ({ prefix = '' }) => {
    const { handleSetBreakKey, handleRemoveBreakKey } = useSetExtendsKeys()
    const { control } = useFormContext<FieldInputFormSlice>()
    const fileDesignPrefix = `${prefix}breakPoint.fileDesign` as const

    return (
        <Group label="宫格样式">
            <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                <InheritLabel label="间距" name={`${fileDesignPrefix}.gap`} />
                <Controller
                    control={control}
                    name={`${fileDesignPrefix}.gap` as never}
                    render={({ field }) => (
                        <GapSizeInput
                            direction="horizontal"
                            value={field.value}
                            onChange={val => {
                                field.onChange(val)
                                handleSetBreakKey(`${fileDesignPrefix}.gap`)
                            }}
                        />
                    )}
                />
            </ListItem4ByecodeUi>

            <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                <InheritLabel label="圆角" name={`${fileDesignPrefix}.borderRadius`} />
                <Controller
                    control={control}
                    name={`${fileDesignPrefix}.borderRadius` as never}
                    render={({ field }) => (
                        <Input
                            style={{ width: 180 }}
                            type="number"
                            min={0}
                            placeholder="请输入"
                            value={field.value ?? ''}
                            onChange={e => {
                                field.onChange(e.currentTarget.value === '' ? undefined : Number(e.currentTarget.value))
                                handleSetBreakKey(`${fileDesignPrefix}.borderRadius`)
                            }}
                        />
                    )}
                />
            </ListItem4ByecodeUi>

            <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                <InheritLabel label="宫格宽度" name={`${fileDesignPrefix}.itemWidth`} />
                <Controller
                    control={control}
                    name={`${fileDesignPrefix}.itemWidth` as never}
                    render={({ field }) => (
                        <RectSizeInput
                            type="width"
                            disableAutoOption
                            disableFillOption
                            value={field.value}
                            onChange={val => {
                                field.onChange(val)
                                handleSetBreakKey(`${fileDesignPrefix}.itemWidth`)
                            }}
                        />
                    )}
                />
            </ListItem4ByecodeUi>

            <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                <InheritLabel label="宫格最多显示个数" name={`${fileDesignPrefix}.maxCount`} />
                <Controller
                    control={control}
                    name={`${fileDesignPrefix}.maxCount` as never}
                    render={({ field }) => (
                        <Input
                            style={{ width: 180 }}
                            type="number"
                            min={1}
                            max={100}
                            placeholder="请输入"
                            value={field.value ?? ''}
                            onChange={e => {
                                field.onChange(e.currentTarget.value === '' ? undefined : Number(e.currentTarget.value))
                                handleSetBreakKey(`${fileDesignPrefix}.maxCount`)
                            }}
                        />
                    )}
                />
            </ListItem4ByecodeUi>
        </Group>
    )
}
